import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import logoImage from '../../assets/images/TELUS-logo.gif';

const Logo = ({ userRights }) => (
  <>
    {_.get(userRights, 'isHomeLinkVisible', true) ? (
      <Link variant="link" to="/">
        <img
          src={logoImage}
          border="0"
          alt="TELUS"
        />
      </Link>
    ) : (
      <img
        src={logoImage}
        border="0"
        style={{ marginTop: '.8em' }}
        alt="TELUS"
      />
    )}
  </>
);

Logo.propTypes = {
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isHomeLinkVisible: PropTypes.bool
  }).isRequired
};

export default Logo;
